const cache = new Map();

export default cache;
